module.exports = __webpack_public_path__ + "static/media/corporate-3.09415ef0.jpg";